export default {
  appTitle: 'Providers web',
  title: 'Authorizations',
  filterLabel: 'Filter by',
  orderLabel: 'Order by',
  authorizationTabLabel: 'Authorizations',
  loadingDataLabel: 'Loading authorizations',
  emptyDataLabel: 'No results found',
  tryAgainLabel: 'Try again with another term or',
  paginationSizeLabel: 'Results/page',
  addAuthorization: 'New authorization',
  addAuthorizationShortLabel: 'New',
  resultLabel: '{result} result | {result} results',
  lastUpdateLabel: 'Last update: {datetime}',
  cleanFilters: 'clean the filters',
  filtersAppliedLabel: 'applied',
  createAuthorization: {
    success: 'The authorization was created successfully.',
    error: 'An error occurred when creating the authorization.'
  },
  filters: {
    status: 'Status',
    from: 'From',
    to: 'To',
    dateRange: 'Date range',
    searchCode: 'Search by ID'
  },
  order: {
    createdAt: 'Creation date',
    beneficiaryName: 'Beneficiary name (a-z)',
    coverageType: 'Coverage (a-z)',
    status: 'Status'
  },
  authorizationGrid: {
    code: 'ID',
    createdAt: 'Creation date',
    sponsor: 'Insurer',
    beneficiary: 'Insured',
    memberCode: 'Card',
    authorizationType: 'Authorization type',
    status: 'Status'
  },
  status: {
    error: 'Error',
    paid: 'Paid',
    voided: 'Voided',
    expired: 'Expired',
    canceled: 'Canceled',
    completed: 'Completed',
    inProgress: 'In progress',
    failed: 'Failed',
    ready: 'Ready',
    expirationInProgress: 'Expiration in progress',
    updateInProgress: 'update in progress'
  },
  types: {
    pharmacy: 'Pharmacy',
    process: 'Process',
    prescriptionDrugs: 'Drugs',
    diagnosticTest: 'Diagnostic test',
    sports: 'Sports',
    wellness: 'Wellness',
    education: 'Education',
    creditCardBalance: 'Debit balance',
    occupationalHazard: 'Occupational hazard'
  },
  tabs: {
    requests: 'Requests',
    newRequest: 'New request',
    profile: 'Profile',
    prescription: 'Prescribe',
    schedule: 'Schedule'
  }
}
